/** =========================================================
 * Roles controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-roles')
    .controller('RolesController', RolesController);

  RolesController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams',
    'ngDialog'
  ];

  function RolesController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams,
    ngDialog
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page roles',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'role',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: ['users', 'permissions']
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Title',
          key: 'name',
          translate: true,
          order: true,
          value: function (item) {
            return item.name.capitalize();
          }
        }, {
          title: 'Users',
          value: function (item) {
            return item.users.map(function (user) {
              return user.name;
            }).join(', ');
          }
        }],
        add: {
          template: 'app/views/dialogs/item-role.html',
          success: $rootScope.getAppConfig
        },
        delete: {
          success: $rootScope.getAppConfig
        },
        customButtons: [{
          icon: 'icon-lock',
          class: 'btn-default',
          title: 'Permissions',
          permission: $rootScope.helpers.hasPermissionTo('role edit_permissions'),
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.getPermissionNamePart = function (name, index) {
                if (name) {
                  return name.split(' ')[index];
                }

                return null;
              };

              dialogScope.hasPermissionTo = function (stack, permission) {
                return stack.filter(function (stackItem) {
                  return stackItem.id === permission.id;
                }).length !== 0;
              };

              dialogScope.togglePermission = function (permission, value) {
                permission.value = value;
              };

              dialogScope.item = angular.copy(item);

              dialogScope.formattedPermissions = {};

              var appPermissions = angular.copy($rootScope.appConfig.permissions);

              appPermissions.forEach(function (permission) {
                var value = dialogScope.hasPermissionTo(dialogScope.item.permissions, permission);

                permission.value = value;

                var permissionModel = dialogScope.getPermissionNamePart(permission.name, 0);

                if (typeof dialogScope.formattedPermissions[permissionModel] === 'undefined') {
                  dialogScope.formattedPermissions[permissionModel] = [];
                }

                dialogScope.formattedPermissions[permissionModel].push(permission);
              });

              ngDialog.openConfirm({
                template: 'app/views/dialogs/role-permissions.html',
                className: 'ngdialog-theme-default ngdialog-wide',
                scope: dialogScope
              }).then(function () {
                $api.update({
                  model: 'role_permissions',
                  data: {
                    role_id: dialogScope.item.id,
                    permissions: appPermissions.filter(function (permission) {
                      return typeof permission.value !== 'undefined';
                    }).map(function (permission) {
                      return {
                        name: permission.name,
                        action: (permission.value ? 'given' : 'revoked')
                      };
                    })
                  }
                }).then(function (response) {
                  item.permissions = response.data;
                });
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
